import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { Table } from 'reactstrap';
import Loader from 'src/components/Shared/Loader';

export type MapObject = {
  id?: string;
  key: string;
  label: string;
  type?: string;
  sortable?: boolean;
  render?: (data: any, rowNo:number, primaryKey?: string, cell?: MapObject) => JSX.Element;
  renderLabel?: (data: any) => JSX.Element | string;
  sortKey?: string;
  className?: string;
  getTdClassName?: (data: any) => string;
  handleColumnClick?: (data: any) => void;
  customExpandIcon?: (data: any) => JSX.Element;
};
export interface ListingType {
  mappings: Array<MapObject>;
  tableClassName?: string;
  dataSource: Array<any>;
  defaultSort?: string;
  isLoading?: boolean;
  primaryKey: string;
  expandRowClassName?: string;
  tableHeaderClassName?: string;
  expanded?: {
    [key: string]: boolean;
  };
  customNoDataComponent?: React.ReactNode;
  additionalComponents?: React.ReactNode;
  getTrClassName?: ((data: any) => string) | null;
  onSortChange?: ((data: any) => void) | null;
  isRowExpandable?: ((data: any) => boolean) | null;
  expandComponent?: ((data: any) => JSX.Element) | null;
  findDataSource?: (id: string) => any;
  generateRowKey?: (data: any) => string;
  handleRowExpand?: ((key: string) => void) | null;

}

const ListingComponent = (props: ListingType) => {
  const {
    mappings,
    dataSource,
    primaryKey,
    expanded = {},
    defaultSort = '',
    generateRowKey = '',
    tableClassName = '',
    expandRowClassName = '',
    tableHeaderClassName = '',
    customNoDataComponent = '',
    additionalComponents = '',
    onSortChange = null,
    getTrClassName = null,
    isRowExpandable = null,
    expandComponent = null,
    findDataSource = null,
    handleRowExpand = null,
    isLoading = false,
  } = props;

  const [sort, setSort] = useState(defaultSort);

  return (
    <React.Fragment>
      {!isEmpty(dataSource) || (customNoDataComponent) ? (
        <Table responsive className={`${tableClassName || ''}`}>
          <thead className={tableHeaderClassName || ''}>
            <tr>
              {Array.isArray(mappings) && mappings?.map((cell) => (
                <React.Fragment key={cell?.id || cell?.key}>
                  {cell?.sortable ? (
                    <th
                      onClick={() => {
                        if (!isEmpty(dataSource)) {
                          const key = sort === cell?.sortKey
                            ? `-${cell?.sortKey}`
                            : cell?.sortKey;
                          setSort(key || '');
                          if (onSortChange) {
                            onSortChange(key);
                          }
                        }
                      }}
                      className={cell.className ?? ''}
                      style={cell?.sortable ? { cursor: 'pointer' } : {}}
                    >
                      {cell?.renderLabel
                        ? cell?.renderLabel(cell)
                        : cell?.label}
                      {cell?.sortKey && cell?.sortable ? (
                        <span
                          className={`sort-wrap ${sort === `-${cell?.sortKey}` ? 'desc' : ''}`}
                        >
                          {sort === cell?.sortKey ? (
                            <svg
                              width="9"
                              height="6"
                              viewBox="0 0 9 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.449914 5.04778H8.55009C8.63908 5.04776 8.72606 5.02136 8.80005 4.97191C8.87403 4.92246 8.9317 4.85218 8.96575 4.76997C8.9998 4.68775 9.00871 4.59728 8.99136 4.51C8.974 4.42272 8.93116 4.34255 8.86824 4.27961L4.81816 0.229525C4.77639 0.18772 4.72679 0.154556 4.6722 0.131929C4.61761 0.109303 4.5591 0.0976563 4.5 0.0976562C4.44091 0.0976563 4.38239 0.109303 4.3278 0.131929C4.27321 0.154556 4.22361 0.18772 4.18184 0.229525L0.131757 4.27961C0.0688415 4.34255 0.0259975 4.42272 0.00864172 4.51C-0.00871405 4.59728 0.000197609 4.68775 0.0342499 4.76997C0.0683021 4.85218 0.125966 4.92246 0.199952 4.97191C0.273938 5.02136 0.360924 5.04776 0.449914 5.04778V5.04778Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="9"
                              height="6"
                              viewBox="0 0 9 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.449914 5.04778H8.55009C8.63908 5.04776 8.72606 5.02136 8.80005 4.97191C8.87403 4.92246 8.9317 4.85218 8.96575 4.76997C8.9998 4.68775 9.00871 4.59728 8.99136 4.51C8.974 4.42272 8.93116 4.34255 8.86824 4.27961L4.81816 0.229525C4.77639 0.18772 4.72679 0.154556 4.6722 0.131929C4.61761 0.109303 4.5591 0.0976563 4.5 0.0976562C4.44091 0.0976563 4.38239 0.109303 4.3278 0.131929C4.27321 0.154556 4.22361 0.18772 4.18184 0.229525L0.131757 4.27961C0.0688415 4.34255 0.0259975 4.42272 0.00864172 4.51C-0.00871405 4.59728 0.000197609 4.68775 0.0342499 4.76997C0.0683021 4.85218 0.125966 4.92246 0.199952 4.97191C0.273938 5.02136 0.360924 5.04776 0.449914 5.04778V5.04778Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          )}
                          {sort === `-${cell?.sortKey}` ? (
                            <svg
                              width="9"
                              height="6"
                              viewBox="0 0 9 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.55009 0.747829H0.449914C0.360924 0.747848 0.273938 0.774251 0.199952 0.8237C0.125966 0.873149 0.0683021 0.943424 0.0342499 1.02564C0.000197609 1.10786 -0.00871405 1.19832 0.00864172 1.28561C0.0259975 1.37289 0.0688415 1.45306 0.131757 1.516L4.18184 5.56608C4.22361 5.60788 4.27321 5.64104 4.3278 5.66366C4.38239 5.68629 4.44091 5.69793 4.5 5.69793C4.55909 5.69793 4.61761 5.68629 4.6722 5.66366C4.72679 5.64104 4.77639 5.60788 4.81816 5.56608L8.86824 1.516C8.93116 1.45306 8.974 1.37289 8.99136 1.28561C9.00871 1.19832 8.9998 1.10786 8.96575 1.02564C8.9317 0.943424 8.87403 0.873149 8.80005 0.8237C8.72606 0.774251 8.63908 0.747848 8.55009 0.747829Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="9"
                              height="6"
                              viewBox="0 0 9 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.55009 0.747829H0.449914C0.360924 0.747848 0.273938 0.774251 0.199952 0.8237C0.125966 0.873149 0.0683021 0.943424 0.0342499 1.02564C0.000197609 1.10786 -0.00871405 1.19832 0.00864172 1.28561C0.0259975 1.37289 0.0688415 1.45306 0.131757 1.516L4.18184 5.56608C4.22361 5.60788 4.27321 5.64104 4.3278 5.66366C4.38239 5.68629 4.44091 5.69793 4.5 5.69793C4.55909 5.69793 4.61761 5.68629 4.6722 5.66366C4.72679 5.64104 4.77639 5.60788 4.81816 5.56608L8.86824 1.516C8.93116 1.45306 8.974 1.37289 8.99136 1.28561C9.00871 1.19832 8.9998 1.10786 8.96575 1.02564C8.9317 0.943424 8.87403 0.873149 8.80005 0.8237C8.72606 0.774251 8.63908 0.747848 8.55009 0.747829Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          )}
                        </span>
                      ) : ''}
                    </th>
                  ) : (
                    <th className="">
                      {cell?.renderLabel
                        ? cell?.renderLabel(cell)
                        : cell?.label}
                    </th>
                  )}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {!isLoading
             && Array.isArray(dataSource)
             && dataSource?.map((row, index) => {
               const data = findDataSource ? findDataSource(row) : row;
               let key = '';
               if (generateRowKey) {
                 key = generateRowKey(data);
               } else if (primaryKey) {
                 key = `tr-${data?.[primaryKey]}`;
               }
               return (
                 <React.Fragment key={key}>
                   <tr
                     className={`${primaryKey && !isEmpty(expanded) && expanded?.[data?.[primaryKey]] ? 'expanded' : ''} ${getTrClassName ? getTrClassName(data) : ''}`}
                   >
                     {Array.isArray(mappings)
                     && mappings?.map((cell) => (
                       <td
                         key={cell?.id || cell?.key}
                         className={`${cell?.className || ''} ${cell?.getTdClassName ? cell?.getTdClassName(data) : ''}`}
                         onClick={() => cell?.handleColumnClick && cell?.handleColumnClick(data)}
                       >
                         {cell?.type === 'expand'
                        && !(isRowExpandable && isRowExpandable(data)) ? (
                          <React.Fragment>
                            {primaryKey
                              && data?.[primaryKey]
                              && expandComponent && (
                                <div
                                  role="presentation"
                                  className={`row-detail ${
                                    expanded && expanded?.[data?.[primaryKey]]
                                      ? 'expanded'
                                      : ''
                                  }`}
                                  onClick={() => handleRowExpand
                                     && handleRowExpand(data?.[primaryKey])}
                                >
                                  {cell?.customExpandIcon ? (
                                    cell?.customExpandIcon(data)
                                  ) : (
                                    <svg
                                      width="8"
                                      height="14"
                                      viewBox="0 0 8 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.31248 6.86783C7.32874 7.07006 7.25951 7.27788 7.10481 7.43258L1.55598 12.9814C1.27598 13.2614 0.822022 13.2614 0.542027 12.9814C0.262033 12.7014 0.262033 12.2475 0.542028 11.9675L5.64166 6.86783L0.542028 1.7682C0.262033 1.48821 0.262032 1.03425 0.542027 0.754252C0.822022 0.474257 1.27598 0.474257 1.55598 0.754252L7.10481 6.30308C7.25951 6.45778 7.32874 6.6656 7.31248 6.86783Z"
                                        fill="black"
                                      />
                                    </svg>
                                  )}
                                </div>
                            )}
                          </React.Fragment>
                           ) : (
                             <React.Fragment>
                               {cell?.render ? cell?.render(data, index + 1, data?.[primaryKey || ''], cell) : data?.[cell?.key]}
                             </React.Fragment>
                           )}
                       </td>
                     ))}
                   </tr>
                   {primaryKey
                    && data?.[primaryKey]
                    && expanded
                    && expanded?.[data?.[primaryKey]]
                    && expandComponent && (
                      <tr className="expanded-row">
                        <td
                          colSpan={mappings?.length}
                          className={`${expandRowClassName || ''}`}
                        >
                          {expandComponent(data)}
                        </td>
                      </tr>
                   )}
                 </React.Fragment>
               );
             })}
            {!isEmpty(dataSource) && !isLoading && additionalComponents ? additionalComponents : ''}
            {isEmpty(dataSource) && !isLoading && customNoDataComponent ? customNoDataComponent : ''}
          </tbody>
        </Table>
      ) : (
        ''
      )}
      {isLoading ? <Loader /> : ''}

      {isEmpty(dataSource) && !isLoading && !customNoDataComponent ? (
        <div className="no-data text-center">No data found</div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default ListingComponent;
